import { createMiddleware, createStart } from "@tanstack/react-start"
import { getRequest } from "@tanstack/react-start/server"

import { isServerFnBlocked } from "@/core/launch"

/** While the site is coming soon the marketing host answers only the marketing server functions (T1310). */
const comingSoonGate = createMiddleware({ type: "function" }).server(({ next, serverFnMeta }) => {
  if (isServerFnBlocked(getRequest(), serverFnMeta.filename)) {
    throw new Response("Not found", { status: 404 })
  }
  return next()
})

export const startInstance = createStart(() => ({ functionMiddleware: [comingSoonGate] }))
